<app-close-button (closeButton)="close()"></app-close-button>
<div class="address_selection_container flex_column_between br_24">
  <div class="address_selection_container--top">
    <div class="description">
      <div class="description--top">
        {{'navbar.find_best_options' | translate}}
      </div>
      <div class="description--bottom">
        {{'address.to_calculate_delivery_cost' | translate}}
      </div>
    </div>
    {{addressNameOrCityNameToDisplay}}
    <div class="search_block">
      <app-search-location
        class="w_100"
        #searchLocationComponent
        (getLocation)="handleNewLocation($event)"
        [locations]="locations"
        [fullAddress]="addressNameOrCityNameToDisplay"
        (searchLocationEmitter)="searchLocation($event)"
        [citySearch]="citySearch"
      >
      </app-search-location>
      <button class="ml_16 confirm_button main_buttons pointer"
              [ngClass]="{disabled: !selectedAddressOrCity}"
              [disabled]="!selectedAddressOrCity" (click)="confirm()">
        {{'buttons.confirm' | translate}}
      </button>
    </div>
    <div class="mt_16 flex_align_center">

      <label class="checkbox">
        <input type="checkbox" [(ngModel)]="citySearch" (ngModelChange)="switchSearchType()">
        <span class="checkmark" [ngClass]="{checked: citySearch}">
          <img src="assets/images/icons/checkbox_icon.svg">
      </span>
      </label>
      <div class="ml_16">
        <div class="confirm_address_with_recipient">
          {{'address.confirm_address_with_recipient' | translate}}
        </div>
        <div class="enter_city_only mt_4">
          {{'address.enter_city_only' | translate}}
        </div>
      </div>
    </div>
  </div>

  <div class="address_selection_container--bottom">
    <div class="address_selection_container--bottom--map">
      <app-map
        #mapComponent
        [showCity]="citySearch"
        (mapReadyEvent)="mapReadyHandler()"
        [city]="selectedAddressOrCity"
        (selectedAddress)="selectAddressInMap($event)"
      ></app-map>
    </div>
  </div>
</div>

